// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar-module_Toolbar_1iofP","Logo":"Toolbar-module_Logo_bUypT","DesktopOnly":"Toolbar-module_DesktopOnly_1P1tT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Toolbar/Toolbar.module.css
// module id = 89
// module chunks = 5